import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const ContentProduct = styled.div`
  background: #e5e7e9;
  max-width: 400px;
  height: 200px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Header = styled.header`
  width: 100%;
  padding: 10px 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 14px;
  }
`

export const Main = styled.main`
  padding: 10px;
  flex: 1;

  h1 {
    font-size: 14px;
  }
`

export const Footer = styled.footer`
  width: 100%;
  padding: 10px 0;

  display: flex;
  align-items: center;
  justify-content: center;
`
